export const GIT_REMOTE_BRANCH_PREFIX = "origin/";

export const GIT_BRANCH_QUERY_KEY = "branch";
